/** @jsx jsx */
import { jsx } from '@emotion/core';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import compose from 'lodash/fp/compose';
import { Container, Row, Column } from '../../../styles/Grid';
import createButtonCss from '../../ui/Button';
import getComponent from '../../../utils/getComponent';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import ContactLineNumber from '../ContactLineNumber';
import { COMPONENT_NAMES } from '../../../utils/constants';
import { processButtonData } from '../../../utils/analytics';
import { NavConsumer, navbar_finite_state } from '../../../contexts/NavContext';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import {
  containerCss,
  topBarCss,
  bottomBarCss,
  stickyContainerCss,
  stickyInnerBarCss,
} from './index.styles';

const stickyTriggerElSelector = '[data-sticky-phone-number-trigger]';

export class StickyBarPhoneNumber extends SafePureComponent {
  stickyTriggerEl = null;
  state = {
    isSticky: false,
  };

  constructor(props) {
    super(props);

    const nav = getComponent(
      get(this.props, 'sitecoreContext'),
      COMPONENT_NAMES.navBar,
    );
    this.phoneNumberFields = get(nav, 'placeholders.jss-phone[0]');
  }

  componentDidMount() {
    this.stickyTriggerEl = document.querySelector(stickyTriggerElSelector);

    if (this.stickyTriggerEl) {
      this.onScrollHandler();
      window.addEventListener('scroll', this.throttledOnScrollHandler);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledOnScrollHandler);
  }

  onScrollHandler = () => {
    const triggerBottom = this.stickyTriggerEl.getBoundingClientRect().bottom;
    this.setState({ isSticky: triggerBottom <= 0 });
  };

  throttledOnScrollHandler = throttle(this.onScrollHandler, 80);

  safeRender() {
    const { isSticky } = this.state;
    const { t } = this.props;
    const componentName = get(this.props, 'rendering.componentName', '');

    return (
      <div css={[containerCss, isSticky && stickyContainerCss]}>
        <div css={[topBarCss, isSticky && stickyInnerBarCss]}>
          <Container>
            <Row>
              <Column cols={{ sm: 6, md: 8, lg: 6 }}>
                <ContactLineNumber
                  {...this.phoneNumberFields}
                  componentName={componentName}
                />
              </Column>
            </Row>
          </Container>
        </div>
        <div
          css={[bottomBarCss, isSticky && stickyInnerBarCss]}
          data-sticky-bottom-bar
        >
          <NavConsumer>
            {({ openModal }) => (
              <button
                css={createButtonCss()}
                onClick={e => {
                  processButtonData(componentName, t('FindWorkspaceCTA'));
                  openModal(e);
                }}
                data-id={navbar_finite_state.SEARCH}
              >
                {t('FindWorkspaceCTA')}
              </button>
            )}
          </NavConsumer>
          <ModalsConsumer>
            {({ openModal }) => (
              <button
                css={createButtonCss('secondary')}
                onClick={() => {
                  processButtonData(componentName, t('GetInTouchCTA'));
                  openModal(modalIds.enquiry);
                }}
              >
                {t('GetInTouchCTA')}
              </button>
            )}
          </ModalsConsumer>
        </div>
      </div>
    );
  }
}

StickyBarPhoneNumber.displayName = 'StickyBarPhoneNumber';

StickyBarPhoneNumber.defaultProps = {
  t: key => key,
};

export default compose(
  withSitecoreContext(),
  withNamespaces(),
)(StickyBarPhoneNumber);
